import styled from 'styled-components';
import { Checkbox as PjCheckbox } from '@prisjakt/ui-inputs';
import { media, colors } from '@prisjakt/ui-base';

export const Checkbox = styled(PjCheckbox)`
  margin-bottom: 1rem;
`;

export const CancelButton = styled.div`
  color: ${p => p.theme.text.primary};
  text-decoration: underline;
  text-transform: none;
  font-weight: normal;
  margin-top: 2rem;
`;

export const EmailInput = styled.div`
  .pj-ui-text-input {
    margin-right: 1rem;
    &--input {
      height: 45px;
    }
  }
  ${media.smallOnly`
    .pj-ui-text-input {
      margin-right: 0;
    }
  `}
  ${p =>
    p.error &&
    `
    .pj-ui-input--input {
      border-color: ${colors.red2};
    }
  `}
`;

export const EmailHint = styled.div.attrs({ 'data-test': 'EmailHint' })`
  && {
    margin: 0.5rem 0;

    display: ${p => (p.visible ? `block` : 'none')};

    a {
      text-decoration: underline !important;
      ${p => p.discreetLink && `color: ${colors.darkGray2};`}
    }

    ${p => p.error && `color: ${colors.red2};`}

    p {
      margin: 0;
    }
  }
`;

export const AlertForm = styled.form`
  ${media.smallOnly`
  .pj-ui-input {
  margin-bottom: 1rem;
  }
  `}
`;
